import React from "react";

const LoadingSpinner = ({ name, bgColor, text, isLight }) => {
  return (
    <div
      className="loading-container flex min-h-[calc(100vh-56px)] flex-col items-center justify-center"
      style={{ backgroundColor: bgColor }}
    >
      <p
        className="font-[cursive] xs:text-xl md:text-3xl"
        style={{ color: text }}
      >
        Loading {name}...
      </p>
      <div
        className="mt-8 h-16 w-16 animate-spin rounded-full border-4 xs:h-20 xs:w-20 md:h-28 md:w-28"
        style={{
          borderLeftColor: text,
          borderRightColor: text,
          borderTopColor: text,
          borderBottomColor: isLight ? "white" : "blue",
        }}
      ></div>
    </div>
  );
};

export default LoadingSpinner;
